module.exports = __webpack_public_path__ + "media/img/decorations/banner-content-after-c26695ee1d4eb5d45010cdbd6a886613.svg";